import { get, post } from '@/utils/http.js'

//获取单位列表
export const getCompanyList = (data) => post('/trxf/main/xf/danwei/xfdanweixinxi/listdata',data);

//单位状态修改
export const switchCompany = (data) => post('/trxf/main/xf/danwei/xfdanweixinxi/stopdouse',data);

//新增单位
export const addCompany = (data) => post('/trxf/main/xf/danwei/xfdanweixinxi/addbase',data);

//编辑单位
export const editCompany = (data) => post('/trxf/main/xf/danwei/xfdanweixinxi/updatebase',data);

//查看单位详情
export const getCompany = (id) => get('/tr_api/v1/unite/detail-unite/'+id);